if (typeof boostPFSThemeConfig !== 'undefined') {
	// Override Settings
  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSConfig.custom.products_per_page,
      /* Optional */
      loadProductFirst: true
      // paginationType: boostPFSConfig.custom.pagination_type.indexOf("load_more") != -1 ? "load_more" :
      // 				(boostPFSConfig.custom.pagination_type == 'infinite_scroll' ? 'infinite' : 'default'),
    },
    selector: {
      trackingQuickView: '.quick_shop'
    }
  };
}

(function () {
  BoostPFS.inject(this);

  // Create our number formatter.
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  
    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  }); 
  
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data, index, totalProduct) {
    if (!data) data = this.data;
    if (!index) index = this.index;
    if (!totalProduct) totalProduct = this.totalProduct;

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    //console.log(data);
    // Add class
    var itemDesktopWidthClass = 'one-third';
    switch (boostPFSConfig.custom.products_per_row) {
      case 1: itemDesktopWidthClass = 'one-whole'; break;
      case 2: itemDesktopWidthClass = 'one-half'; break;
      case 3: itemDesktopWidthClass = 'one-third'; break;
      case 4: itemDesktopWidthClass = 'one-fourth'; break;
      case 5: itemDesktopWidthClass = 'one-fifth'; break;
      case 6: itemDesktopWidthClass = 'one-sixth'; break;
      case 7: itemDesktopWidthClass = 'one-seventh'; break;
      case 8: itemDesktopWidthClass = 'one-eighth'; break;
    }
    itemHtml = itemHtml.replace(/{{itemDesktopWidthClass}}/g, itemDesktopWidthClass);
    itemHtml = itemHtml.replace(/{{itemMobileWidthClass}}/g, boostPFSConfig.custom.mobile_products_per_row == 1 ? 'small-down--one-whole' : 'small-down--one-half');
    itemHtml = itemHtml.replace(/{{itemQuickShopClass}}/g, boostPFSConfig.custom.enable_quickshop ? 'quick-shop--true quick-shop--closed product-{{itemId}} js-product_section' : '');
    itemHtml = itemHtml.replace(/{{itemStickersClass}}/g, boostPFSConfig.custom.stickers_enabled ? 'has-thumbnail-sticker' : '');
    itemHtml = itemHtml.replace(/{{itemHoverClass}}/g, boostPFSConfig.custom.thumbnail_hover_enabled?.toString());
    itemHtml = itemHtml.replace(/{{itemSwapImageClass}}/g, boostPFSConfig.custom.show_secondary_image && data.images_info.length > 1 ? 'swap--true' : '');
    itemHtml = itemHtml.replace(/{{itemHoverImage}}/g, boostPFSConfig.custom.show_secondary_image && data.images_info.length > 1 ? 'has-secondary-image-swap' : '');
    itemHtml = itemHtml.replace(/{{itemTextAlignClass}}/g, boostPFSConfig.custom.thumbnail_text_alignment);

    // Add custom
    // if (data.variants[0].compare_at_price) {
    //   var itemPercentOff = data.variants[0].compare_at_price - data.variants[0].price;
    //   if(itemPercentOff != 0){
    //     itemHtml = itemHtml.replace(/{{itemPercentOff}}/g, `<span class="price-savings-badge">`+formatter.format(itemPercentOff).concat(" OFF")+`</span>`);
    //     // itemHtml = itemHtml.replace(/{{itemPercentOff}}/g, `<span class="price-savings-badge">CYBER MONDAY SALE</span>`);
    //   }
    //   else{
    //     itemHtml = itemHtml.replace(/{{itemPercentOff}}/g, '');
    //   }
    // }
    // else {
    //   itemHtml = itemHtml.replace(/{{itemPercentOff}}/g, '');
    // }
    // Add stickers
    var itemStickers = buildStickers(data);
    itemHtml = itemHtml.replace(/{{itemStickers}}/g, itemStickers);

    // Add images
    var itemImages = buildImages(data);
    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImages);

    // Add hover elements
    var itemHover = buildHover(data);
    itemHtml = itemHtml.replace(/{{itemHover}}/g, itemHover);

    // Add product info
    itemHtml = itemHtml.replace(/{{itemProductInfo}}/g, boostPFSTemplate.itemProductInfoHtml);

    // Add vendor
    var itemVendor = boostPFSConfig.custom.display_vendor ? '<span class="product-thumbnail__vendor">{{itemVendor}}</span>' : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendor);

    var collectionHandles = data.collections.map(x => x.handle);
    var isComingSoon = collectionHandles.indexOf('coming-soon') != -1;
    // Add coming soon
    if (isComingSoon) {
      itemHtml = itemHtml.replace(/{{itemComingSoon}}/g, '<span>' + boostPFSConfig.label.coming_soon + '</span>');
      itemHtml = itemHtml.replace(/{{itemPrice}}/g, '');

      // Add price
    } else {
      itemHtml = itemHtml.replace(/{{itemComingSoon}}/g, '');
      itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
    }

    // Add swatch
    var itemSwatch = buildSwatch(data);
    itemHtml = itemHtml.replace(/{{itemSwatch}}/g, itemSwatch);

    // Add Reviews
    if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
      var itemReviews = boostPFSConfig.custom.enable_shopify_collection_badges && boostPFSConfig.custom.enable_shopify_review_comments ? '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>' : '';
      if (boostPFSConfig.custom.thumbnail_hover_enabled) {
        itemHtml = itemHtml.replace(/{{itemReviewsHover}}/g, itemReviews);
        itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
      } else {
        if (itemReviews != '') {
          itemReviews = '<div class="product-thumbnail__review-stars is-flex is-justify-' + boostPFSConfig.custom.thumbnail_text_alignment + '">' +
            '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>' +
            '</div>';
        }
        itemHtml = itemHtml.replace(/{{itemReviewsHover}}/g, '');
        itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviews);
      }
    }

    // Add quick shop button placeholder
    var itemQuickShop = boostPFSConfig.custom.enable_quickshop ? '<div data-boost-pfs-quickshop-id="{{itemId}}" style="display: none"></div>' : '';
    itemHtml = itemHtml.replace(/{{itemQuickShop}}/g, itemQuickShop);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));

    itemHtml = itemHtml.replace(/{{itemShipping}}/g, buildShipping(data));

    // Add heater key details table
    itemHtml = itemHtml.replace(/{{itemHeaterDetails}}/g, buildHeaterDetails(data));

    return itemHtml;
  };

  
  function buildShipping(data){
    var freeShippingHtml = `<div class="shipping-price free-shipping">+ Free Shipping</div>`;
    var shippingHtml = `<div class="shipping-price free-shipping">+ Shipping</div>`;
    
    if(checkFreeShipping(data.metafields)){
      return freeShippingHtml;
    }
    else{
      return shippingHtml;
    }
  }
  function checkFreeShipping(arr) {
    for (const item of arr) {
        if (item.key === "is_free_shipping") {
            return item.value === "true";
        }
    }
    // If the key "is_free_shipping" is not found, return true
    return true;
  }

  // Key details table — mirrors snippets/heater-card-details.liquid. Renders a
  // product's key-detail rows (heater set: Type/Power/Electrical/Sauna Sizing/
  // Controls, or sauna set: Type/Capacity/Heat Source/Exterior Dimensions/
  // Temperature), em-dash for blanks so card heights stay uniform. Rows come
  // from the server-rendered window.boostHeaterDetails map (collection__main),
  // with data.metafields as a fallback; pages with neither render nothing.
  // DETAIL_ICONS keys must stay in sync with snippets/key-detail-icon.liquid.
  var DETAIL_ICONS = {
    flame: '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M18.8072 3.03458C18.5146 2.70629 18.0026 2.87196 17.9501 3.28002C17.7269 5.56762 17.4986 7.58501 16.9089 9.17049C16.2612 11.0433 15.2183 12.2082 13.6218 14.1883C12.8552 15.1697 11.8868 16.4095 11.3256 18.1503C10.8451 19.7877 10.8475 21.4032 11.155 22.841C11.6902 25.3716 12.9275 27.5357 14.7294 29.1261C15.0335 29.3969 15.4997 29.1622 15.5235 28.7483C15.5168 26.4143 15.5095 24.3791 15.7834 22.5803C15.9579 21.5689 16.1954 20.6898 16.5418 20.0121C16.8074 19.4378 17.3781 18.6858 18.1389 17.7331C18.8709 16.7745 19.7586 15.6381 20.3996 14.2424C21.0693 12.8526 21.4233 11.2493 21.4034 9.7201C21.3053 7.09841 20.3269 4.8371 18.8072 3.03458Z" fill="#253455"/><path d="M12.6599 1.04436C12.4364 0.67022 11.8844 0.738074 11.7686 1.16325C11.3629 2.72612 10.998 4.08785 10.3921 5.16165C9.70529 6.48823 8.80694 7.23374 7.37856 8.53006C6.71037 9.17256 5.85786 9.98715 5.21718 11.2333C4.68012 12.4108 4.49946 13.6004 4.5719 14.7216C4.67734 16.5672 5.30639 18.1897 6.34992 19.5371C6.6079 19.8883 7.14862 19.7284 7.22993 19.3261C7.46897 17.6997 7.69609 16.2802 8.06657 15.0392C8.30377 14.3096 8.58101 13.6778 8.91541 13.207C9.17492 12.8109 9.69333 12.3176 10.3557 11.7038C10.9894 11.0842 11.7728 10.3155 12.4129 9.36822C13.0529 8.42097 13.498 7.25486 13.6383 6.11687C13.9067 4.1973 13.502 2.50055 12.6599 1.04436Z" fill="#253455"/><path d="M27.4421 16.8324C27.4632 14.9525 26.84 13.3013 25.8539 11.9656C25.596 11.6144 25.0323 11.7397 24.9739 12.1765C24.7694 13.78 24.5481 15.1708 24.0801 16.3023C23.5599 17.6925 22.7303 18.5416 21.4798 19.9935C20.8862 20.7109 20.1312 21.6349 19.6629 22.916C19.2637 24.1512 19.2325 25.3411 19.4257 26.4568C19.7497 28.2569 20.5686 29.828 21.7561 31.0549C22.0544 31.3545 22.5722 31.1601 22.596 30.7462C22.6569 29.1137 22.6829 27.6535 22.9384 26.3893C23.0894 25.6422 23.2863 24.9643 23.569 24.4532C23.8056 24.0225 24.2436 23.483 24.8314 22.7944C25.3905 22.0999 26.0993 21.2563 26.6073 20.2225C27.1212 19.16 27.4226 17.9649 27.4421 16.8324Z" fill="#253455"/></svg>',
    bolt: '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M19.3333 1.33337C19.5688 1.33337 19.7902 1.44794 19.9265 1.64036C20.0628 1.83278 20.0973 2.07922 20.0192 2.30153L15.7173 14.6667H24.6667C24.9276 14.6667 25.1664 14.8125 25.286 15.0445C25.4056 15.2765 25.3858 15.5556 25.2347 15.7677L13.2347 30.434C13.0822 30.6478 12.8085 30.7335 12.5634 30.6444C12.3183 30.5552 12.1602 30.3134 12.1739 30.0517L12.948 17.3334H7.33333C7.07983 17.3334 6.84576 17.198 6.71929 16.9783C6.59282 16.7587 6.59307 16.4878 6.71995 16.2683L18.7533 1.6683C18.8742 1.45914 19.0984 1.33337 19.3393 1.33337H19.3333Z" fill="#253455"/></svg>',
    plug: '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M22.6667 12V4C22.6667 3.26667 22.0667 2.66667 21.3333 2.66667C20.6 2.66667 20 3.26667 20 4V12H12V4C12 3.26667 11.4 2.66667 10.6667 2.66667C9.93333 2.66667 9.33333 3.26667 9.33333 4V12H8C7.26667 12 6.66667 12.6 6.66667 13.3333V17.3333C6.66667 21.5067 9.49333 25.0133 13.3333 26.04V28C13.3333 29.4733 14.5267 30.6667 16 30.6667C17.4733 30.6667 18.6667 29.4733 18.6667 28V26.04C22.5067 25.0133 25.3333 21.5067 25.3333 17.3333V13.3333C25.3333 12.6 24.7333 12 24 12H22.6667Z" fill="#253455"/></svg>',
    diamond: '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M28.9428 7.94281L24.0572 3.05719C23.276 2.27614 22.0097 2.27614 21.2286 3.05719L3.05719 21.2286C2.27614 22.0096 2.27614 23.276 3.05719 24.0571L7.94282 28.9428C8.72387 29.7238 9.99019 29.7238 10.7712 28.9428L28.9428 10.7712C29.7238 9.99014 29.7238 8.72381 28.9428 7.94281ZM9.35699 26.8214L5.17855 22.6429L6.59276 21.2287L8.41421 23.0501C8.80473 23.4407 9.43789 23.4407 9.82842 23.0501C10.2189 22.6596 10.2189 22.0265 9.82842 21.6359L8.00698 19.8144L9.41419 18.4072L11.2356 20.2287C11.6262 20.6192 12.2593 20.6192 12.6499 20.2287C13.0404 19.8381 13.0404 19.205 12.6499 18.8144L10.8285 16.993L12.2356 15.5858L14.0571 17.4073C14.4476 17.7978 15.0807 17.7978 15.4713 17.4073C15.8618 17.0168 15.8618 16.3836 15.4713 15.9931L13.6499 14.1716L15.0571 12.7644L16.8785 14.5859C17.2691 14.9764 17.9022 14.9764 18.2927 14.5859C18.6833 14.1953 18.6833 13.5622 18.2927 13.1717L16.4713 11.3502L17.8785 9.94304L19.6999 11.7645C20.0905 12.155 20.7236 12.155 21.1142 11.7645C21.5047 11.3739 21.5047 10.7408 21.1142 10.3503L19.2927 8.52883L20.6999 7.12162L22.5214 8.94306C22.9119 9.33358 23.5451 9.33358 23.9356 8.94306C24.3261 8.55254 24.3261 7.91939 23.9356 7.52887L22.1142 5.70742L23.5285 4.29307L26.8214 7.58593L9.35699 26.8214Z" fill="#253455"/></svg>',
    wifi: '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><g transform="translate(2.5 3.5) scale(0.84)"><path d="M16 27.3333C17.4728 27.3333 18.6667 26.1394 18.6667 24.6667C18.6667 23.1939 17.4728 22 16 22C14.5272 22 13.3333 23.1939 13.3333 24.6667C13.3333 26.1394 14.5272 27.3333 16 27.3333Z" fill="#253455"/><path d="M16 16C12.7027 16 9.61067 17.284 7.286 19.6093C6.766 20.1293 6.766 20.9707 7.286 21.4907C7.806 22.0107 8.64733 22.0107 9.16733 21.4907C10.9933 19.6647 13.42 18.6667 16 18.6667C18.58 18.6667 21.0067 19.6647 22.8327 21.4907C23.0927 21.7507 23.4333 21.8807 23.774 21.8807C24.1147 21.8807 24.4553 21.7507 24.7153 21.4907C25.2353 20.9707 25.2353 20.1293 24.7153 19.6093C22.3893 17.284 19.2973 16 16 16Z" fill="#253455"/><path d="M16 10C11.6213 10 7.50267 11.704 4.40267 14.804C3.88267 15.324 3.88267 16.1653 4.40267 16.6853C4.92267 17.2053 5.764 17.2053 6.284 16.6853C8.88067 14.0887 12.3327 12.6667 16 12.6667C19.6673 12.6667 23.1193 14.0887 25.716 16.6853C25.976 16.9453 26.3167 17.0753 26.6573 17.0753C26.998 17.0753 27.3387 16.9453 27.5987 16.6853C28.1187 16.1653 28.1187 15.324 27.5987 14.804C24.4987 11.704 20.3787 10 16 10Z" fill="#253455"/><path d="M16 4C10.064 4 4.48267 6.31067 0.282667 10.5107C-0.237333 11.0307 -0.237333 11.872 0.282667 12.392C0.802667 12.912 1.644 12.912 2.164 12.392C5.85867 8.69733 10.7733 6.66667 16 6.66667C21.2267 6.66667 26.1413 8.69733 29.836 12.392C30.096 12.652 30.4367 12.782 30.7773 12.782C31.118 12.782 31.4587 12.652 31.7187 12.392C32.2387 11.872 32.2387 11.0307 31.7187 10.5107C27.5187 6.31067 21.936 4 16 4Z" fill="#253455"/></g></svg>',
    house: '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M30.5095 13.4382L16.2873 1.43816C16.1215 1.29861 15.8797 1.29861 15.7139 1.43816L1.49173 13.4382C1.39661 13.5182 1.33973 13.6346 1.33439 13.7591C1.32906 13.8835 1.37617 14.0044 1.46417 14.0924L3.24195 15.8702C3.40506 16.0333 3.66639 16.0444 3.84284 15.8955L16.0006 5.63727L28.1584 15.8955C28.2415 15.9653 28.3433 15.9999 28.4451 15.9999C28.5593 15.9999 28.6731 15.9559 28.7593 15.8697L30.5371 14.0919C30.6251 14.0039 30.6722 13.8831 30.6668 13.7586C30.6615 13.6346 30.6046 13.5182 30.5095 13.4382Z" fill="#253455"/><path d="M16.2922 6.77463C16.1251 6.63063 15.878 6.63063 15.7109 6.77463L5.93307 15.2191C5.8353 15.3035 5.7793 15.4262 5.7793 15.5555V30.2222C5.7793 30.4675 5.97841 30.6666 6.22374 30.6666H25.7793C26.0246 30.6666 26.2237 30.4675 26.2237 30.2222V15.5555C26.2237 15.4262 26.1677 15.3035 26.07 15.2191L16.2922 6.77463ZM22.6682 27.1111V29.7777H21.7793V26.6666C21.7793 26.4222 21.9793 26.2222 22.2237 26.2222H25.3349V27.1111H22.6682ZM6.66819 27.1111V26.2222H9.7793C10.0237 26.2222 10.2237 26.4222 10.2237 26.6666V29.7777H9.33485V27.1111H6.66819ZM20.0326 20.1822C19.1526 19.3022 18.6682 18.1333 18.6682 16.8888C18.6682 15.6444 19.1526 14.4755 20.0326 13.5955C20.3793 13.2488 20.9437 13.2444 21.2904 13.5955C21.6371 13.9422 21.6371 14.5022 21.2904 14.8488C20.7437 15.3955 20.446 16.12 20.446 16.8888C20.446 17.6577 20.7437 18.3822 21.2904 18.9288C23.1082 20.7422 23.1082 23.7022 21.2904 25.5155C21.1171 25.6888 20.8904 25.7777 20.6637 25.7777C20.4326 25.7777 20.206 25.6888 20.0326 25.5155C19.686 25.1688 19.686 24.6088 20.0326 24.2622C20.5793 23.7155 20.8771 22.9911 20.8771 22.2222C20.8771 21.4533 20.5793 20.7288 20.0326 20.1822ZM15.3749 18.4044C13.5571 16.5911 13.5571 13.6311 15.3749 11.8177C15.7215 11.4666 16.2815 11.4666 16.6282 11.8177C16.9793 12.1644 16.9793 12.7244 16.6282 13.0711C16.086 13.6177 15.7837 14.3422 15.7837 15.1111C15.7837 15.88 16.086 16.6044 16.6282 17.1511C18.446 18.9644 18.446 21.9244 16.6282 23.7377C16.4549 23.9111 16.2282 24 16.0015 24C15.7749 24 15.5482 23.9111 15.3749 23.7377C15.0237 23.3911 15.0237 22.8311 15.3749 22.4844C15.9171 21.9377 16.2193 21.2133 16.2193 20.4444C16.2193 19.6755 15.9171 18.9511 15.3749 18.4044ZM11.1437 20.1822C10.2637 19.3022 9.7793 18.1333 9.7793 16.8888C9.7793 15.6444 10.2637 14.4755 11.1437 13.5955C11.4904 13.2488 12.0549 13.2444 12.4015 13.5955C12.7482 13.9422 12.7482 14.5022 12.4015 14.8488C11.8549 15.3955 11.5571 16.12 11.5571 16.8888C11.5571 17.6577 11.8549 18.3822 12.4015 18.9288C14.2193 20.7422 14.2193 23.7022 12.4015 25.5155C12.2282 25.6888 12.0015 25.7777 11.7749 25.7777C11.5437 25.7777 11.3171 25.6888 11.1437 25.5155C10.7971 25.1688 10.7971 24.6088 11.1437 24.2622C11.6904 23.7155 11.9882 22.9911 11.9882 22.2222C11.9882 21.4533 11.6904 20.7288 11.1437 20.1822Z" fill="#253455"/></svg>',
    person: '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M15.9995 16C19.7328 16 22.6662 13.0666 22.6662 9.33329C22.6662 5.59996 19.7328 2.66663 15.9995 2.66663C12.2662 2.66663 9.33282 5.59996 9.33282 9.33329C9.33282 13.0666 12.2662 16 15.9995 16ZM28.3995 27.7333C26.6662 20.9333 19.7328 16.6666 12.9328 18.4C8.39949 19.6 4.79949 23.0666 3.59949 27.7333C3.46615 28.4 3.86615 29.2 4.66615 29.3333H4.93282H27.0662C27.8661 29.3333 28.3995 28.8 28.3995 28C28.3995 27.8666 28.3995 27.7333 28.3995 27.7333Z" fill="#253455"/></svg>',
    expand: '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M13.7505 8.2584C13.9419 8.44984 14.2291 8.54557 14.4844 8.54557C14.7396 8.54557 14.9949 8.44984 15.2182 8.2584C15.633 7.8436 15.633 7.20545 15.2182 6.79065L14.1334 5.70579H27.6622L26.5774 6.79065C26.1626 7.20545 26.1626 7.8436 26.5774 8.2584C26.7688 8.44984 27.056 8.54557 27.3112 8.54557C27.5665 8.54557 27.8218 8.44984 28.0451 8.2584L30.8849 5.41862C31.2997 5.00382 31.2997 4.36567 30.8849 3.95087L28.0451 1.11109C27.6303 0.696288 26.9922 0.696288 26.5774 1.11109C26.1626 1.52589 26.1626 2.16404 26.5774 2.57884L27.6622 3.6637H14.1334L15.1863 2.61075C15.6011 2.19595 15.6011 1.55779 15.1863 1.14299C14.7715 0.728195 14.1334 0.728195 13.7186 1.14299L10.9107 3.98277C10.4959 4.39757 10.4959 5.03573 10.9107 5.45052L13.7505 8.2584Z" fill="#253455"/><path d="M6.79535 15.1824C6.98679 15.3738 7.27396 15.4695 7.52922 15.4695C7.78448 15.4695 8.03974 15.3738 8.2631 15.1824C8.6779 14.7676 8.6779 14.1294 8.2631 13.7146L5.42332 10.9067C5.00852 10.4919 4.37037 10.4919 3.95557 10.9067L1.11579 13.7465C0.700988 14.1613 0.700988 14.7995 1.11579 15.2143C1.53059 15.6291 2.16874 15.6291 2.58354 15.2143L3.6684 14.1294V27.6582L2.61545 26.6053C2.20065 26.1905 1.56249 26.1905 1.14769 26.6053C0.732896 27.0201 0.732896 27.6582 1.14769 28.073L3.98747 30.9128C4.17892 31.1043 4.46609 31.2 4.72135 31.2C4.97661 31.2 5.23187 31.1043 5.45523 30.9128L8.29501 28.073C8.7098 27.6582 8.7098 27.0201 8.29501 26.6053C7.88021 26.1905 7.24205 26.1905 6.82725 26.6053L5.74239 27.6902V14.1294L6.79535 15.1824Z" fill="#253455"/><path d="M30.1505 10.6196H11.6441C11.0698 10.6196 10.623 11.0663 10.623 11.6406V30.147C10.623 30.7214 11.0698 31.1681 11.6441 31.1681H30.1505C30.7249 31.1681 31.1716 30.7214 31.1716 30.147V11.6406C31.1716 11.0663 30.7249 10.6196 30.1505 10.6196Z" fill="#253455"/></svg>',
    thermometer: '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M21.1441 16.4694V5.14437C21.1441 3.78 20.6021 2.47151 19.6373 1.50675C18.6726 0.541995 17.3641 0 15.9997 0C14.6353 0 13.3268 0.541995 12.3621 1.50675C11.3973 2.47151 10.8553 3.78 10.8553 5.14437V16.4694C9.77658 17.2711 8.90061 18.3143 8.2976 19.5154C7.69458 20.7166 7.38129 22.0422 7.38282 23.3862C7.38282 28.1006 11.2241 31.9669 15.9378 32H16.0003C17.8117 31.9999 19.5769 31.429 21.0453 30.3685C22.5137 29.3079 23.6106 27.8117 24.1802 26.0922C24.7498 24.3727 24.763 22.5175 24.2181 20.7901C23.6732 19.0626 22.5978 17.5508 21.1447 16.4694H21.1441ZM15.9997 29.625H15.9547C14.8898 29.6167 13.8447 29.3362 12.9187 28.8102C11.9927 28.2843 11.2166 27.5302 10.6641 26.6198C10.1116 25.7094 9.80105 24.6728 9.762 23.6086C9.72294 22.5444 9.95666 21.4878 10.4409 20.5394C10.8802 19.6882 11.5073 18.9481 12.2747 18.375L13.2303 17.6631V5.14437C13.2303 4.40989 13.5221 3.70549 14.0415 3.18613C14.5608 2.66677 15.2652 2.375 15.9997 2.375C16.7342 2.375 17.4386 2.66677 17.9579 3.18613C18.4773 3.70549 18.7691 4.40989 18.7691 5.14437V17.6619L19.7247 18.375C20.4921 18.9482 21.1189 19.6886 21.5578 20.54C22.0105 21.4196 22.2451 22.3951 22.2416 23.3844C22.2391 25.0389 21.5806 26.625 20.4105 27.7949C19.2405 28.9647 17.6543 29.6229 15.9997 29.625Z" fill="#253455"/><path d="M17.1242 19.0375V9.38373C17.1242 9.08536 17.0056 8.79921 16.7946 8.58823C16.5837 8.37725 16.2975 8.25873 15.9992 8.25873C15.7008 8.25873 15.4146 8.37725 15.2037 8.58823C14.9927 8.79921 14.8742 9.08536 14.8742 9.38373V19.0375C13.8166 19.3112 12.8951 19.9612 12.2824 20.8657C11.6696 21.7701 11.4077 22.867 11.5457 23.9507C11.6837 25.0344 12.2121 26.0306 13.0319 26.7526C13.8517 27.4746 14.9067 27.873 15.9992 27.873C17.0916 27.873 18.1466 27.4746 18.9664 26.7526C19.7862 26.0306 20.3146 25.0344 20.4526 23.9507C20.5906 22.867 20.3287 21.7701 19.7159 20.8657C19.1032 19.9612 18.1817 19.3112 17.1242 19.0375Z" fill="#253455"/><path d="M23.668 6.25H28.188C28.4863 6.25 28.7725 6.13147 28.9835 5.9205C29.1944 5.70952 29.313 5.42337 29.313 5.125C29.313 4.82663 29.1944 4.54048 28.9835 4.3295C28.7725 4.11853 28.4863 4 28.188 4H23.668C23.3696 4 23.0835 4.11853 22.8725 4.3295C22.6615 4.54048 22.543 4.82663 22.543 5.125C22.543 5.42337 22.6615 5.70952 22.8725 5.9205C23.0835 6.13147 23.3696 6.25 23.668 6.25Z" fill="#253455"/><path d="M28.188 13.6412H23.668C23.3696 13.6412 23.0835 13.7598 22.8725 13.9707C22.6615 14.1817 22.543 14.4679 22.543 14.7662C22.543 15.0646 22.6615 15.3508 22.8725 15.5617C23.0835 15.7727 23.3696 15.8912 23.668 15.8912H28.188C28.4863 15.8912 28.7725 15.7727 28.9835 15.5617C29.1944 15.3508 29.313 15.0646 29.313 14.7662C29.313 14.4679 29.1944 14.1817 28.9835 13.9707C28.7725 13.7598 28.4863 13.6412 28.188 13.6412Z" fill="#253455"/><path d="M23.668 11.0712H25.9286C26.227 11.0712 26.5131 10.9527 26.7241 10.7417C26.9351 10.5307 27.0536 10.2446 27.0536 9.94623C27.0536 9.64786 26.9351 9.36171 26.7241 9.15073C26.5131 8.93975 26.227 8.82123 25.9286 8.82123H23.668C23.5202 8.82123 23.3739 8.85033 23.2374 8.90686C23.101 8.9634 22.9769 9.04627 22.8725 9.15073C22.768 9.2552 22.6851 9.37922 22.6286 9.51571C22.5721 9.6522 22.543 9.79849 22.543 9.94623C22.543 10.094 22.5721 10.2403 22.6286 10.3767C22.6851 10.5132 22.768 10.6373 22.8725 10.7417C22.9769 10.8462 23.101 10.9291 23.2374 10.9856C23.3739 11.0421 23.5202 11.0712 23.668 11.0712Z" fill="#253455"/></svg>'
  };

  function getMetafieldValue(metafields, key) {
    if (!Array.isArray(metafields)) return '';
    for (var i = 0; i < metafields.length; i++) {
      if (metafields[i] && metafields[i].key === key && metafields[i].value != null) {
        return String(metafields[i].value);
      }
    }
    return '';
  }

  // Field specs for the data.metafields fallback (used when a product isn't in
  // the server-rendered map, e.g. paginated past it). icon = DETAIL_ICONS key.
  var HEATER_FIELDS = [
    { icon: 'flame', label: 'Type', key: 'heater_key_details_type' },
    { icon: 'bolt', label: 'Power', key: 'heater_key_details_power' },
    { icon: 'plug', label: 'Electrical', key: 'heater_key_details_electrical' },
    { icon: 'diamond', label: 'Sauna Sizing', key: 'heater_key_details_sauna_sizing' },
    { icon: 'wifi', label: 'Controls', key: 'heater_key_details_controls' }
  ];

  var SAUNA_FIELDS = [
    { icon: 'house', label: 'Type', key: 'key_details_type' },
    { icon: 'person', label: 'Capacity', key: 'key_details_capacity' },
    { icon: 'flame', label: 'Heat Source', key: 'key_details_heat_source' },
    { icon: 'expand', label: 'Exterior Dimensions', key: 'key_details_exterior_dimensions' },
    { icon: 'thermometer', label: 'Temperature', key: 'key_details_temperature' }
  ];

  // Build rows from data.metafields — heater set if any present, else sauna set.
  // Returns an array of {icon, label, value} or null.
  function rowsFromMetafields(metafields) {
    var sets = [HEATER_FIELDS, SAUNA_FIELDS];
    for (var s = 0; s < sets.length; s++) {
      var rows = sets[s].map(function (f) {
        return { icon: f.icon, label: f.label, value: getMetafieldValue(metafields, f.key) };
      });
      var hasAny = rows.some(function (r) { return r.value && r.value.trim() !== ''; });
      if (hasAny) return rows;
    }
    return null;
  }

  function buildHeaterDetails(data) {
    var map = window.boostHeaterDetails;
    var rows = (map && map[data.id]) || rowsFromMetafields(data.metafields);
    if (!rows || !rows.length) return '';

    var dash = '—';
    var itemsHtml = rows.map(function (r) {
      var value = (r.value != null && String(r.value).trim() !== '') ? r.value : dash;
      var icon = DETAIL_ICONS[r.icon] || '';
      return '<div class="card-key-details__item">' +
        '<span class="card-key-details__icon">' + icon + '</span>' +
        '<span class="card-key-details__label">' + r.label + '</span>' +
        '<span class="card-key-details__value">' + value + '</span>' +
        '</div>';
    }).join('');

    return '<div class="card-key-details"><div class="card-key-details__list">' + itemsHtml + '</div></div>';
  }

  function buildStickers(data) {
    var html = '';
    var stickers = [];
    if (boostPFSConfig.custom.stickers_enabled) {
      var collections = data.collections.map(x => x.handle);
      var stickerCollections = ['best-seller', 'coming-soon', 'new', 'pre-order', 'staff-pick'];
      for (var i = 0; i < stickerCollections.length; i++) {
        var stickerCollection = stickerCollections[i];
        if (collections.indexOf(stickerCollection) != -1) {
          var stickerText = boostPFSConfig.label[stickerCollection.replace('-', '_')];
          var sticker = '<div class="' + stickerCollection + '-sticker thumbnail-sticker sticker-' + i + '"><span class="sticker-text">' + stickerText + '</span></div>';
          stickers.push(sticker);
        }
      }

      var onSale = data.available && data.price_min < data.compare_at_price_max;
      var soldOut = !data.available;

      if (onSale) {
        var sticker = '<div class="sale-sticker thumbnail-sticker"><span class="sticker-text">' + boostPFSConfig.label.sale + '</span></div>';
        stickers.push(sticker);
      } else if (soldOut) {
        var sticker = '<div class="sale-sticker thumbnail-sticker"><span class="sticker-text">' + boostPFSConfig.label.sold_out + '</span></div>';
        stickers.push(sticker);
      }

      if (stickers.length > 0) {
        html = '<div class="sticker-holder sticker-shape-' + boostPFSConfig.custom.sticker_shape + ' sticker-position-' + boostPFSConfig.custom.sticker_position + '">' +
          '<div class="sticker-holder__content sticker-holder__content--">' +
          stickers.join('') +
          '</div>' +
          '</div>';
      }
    }
    return html;
  }

  function buildImages(data) {
    var html = '';
    var images = data.images_info;
    if (!images || images.length == 0) {
      images.push({
        src: boostPFSAppConfig.general.no_image_url,
        width: 480,
        height: 480
      })
    }

    html += buildImageElement(images[0]);

    if (boostPFSConfig.custom.show_secondary_image && images.length > 1) {
      html += buildImageElement(images[1], 'lazypreload secondary swap--visible');
    }

    return html;
  }

  function buildImageElement(image, additionalClass) {
    var additionalClass = (typeof additionalClass !== 'undefined') ? additionalClass : '';
    var html = '';
    var heightStyle = '';
    var widthStyle = '';
    var aspectRatio = image.width / image.height;
    if (boostPFSConfig.custom.align_height) {
      heightStyle += 'max-height: ' + boostPFSConfig.custom.collection_height + 'px;';
      widthStyle += 'width: calc(' + image.width + ' / ' + image.height + ' * ' + boostPFSConfig.custom.collection_height + 'px)';
      // widthStyle += 'width: '+ (aspectRatio * boostPFSConfig.custom.collection_height) +'px; max-width: '+ image.width +'px;';
    }

    var backgroundColor = boostPFSConfig.custom.image_loading_style == 'color' ? 'background: url(' + Utils.optimizeImage(image.src, '1x') + '); ' : '';
    var lowQualityImage = boostPFSConfig.custom.image_loading_style == 'blur-up' ? Utils.optimizeImage(image.src, '50x') : '';

    html += '<div class="image-element__wrap" style="' + backgroundColor + heightStyle + widthStyle + '">' +
      '<img alt="{{itemTitle}}"' +
      ' class="lazyload transition--' + boostPFSConfig.custom.image_loading_style + ' ' + additionalClass + '"' +
      (lowQualityImage && lowQualityImage !== '' ?
        ' src="' + lowQualityImage + '"' : '') +
      ' data-src="' + Utils.optimizeImage(image.src, '1600x') + '"' +
      ' data-sizes="auto"' +
      ' data-aspectratio="' + aspectRatio + '"' +
      ' data-srcset="' + bgset(image) + '"' +
      ' srcset="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="' +
      ' height="' + image.height + '"' +
      ' width="' + image.width + '"' +
      ' style="' + heightStyle + '"' +
      '/>' +
      '</div>';
    return html;
  }

  function buildHover(data) {
    var html = '';
    if (boostPFSConfig.custom.enable_quickshop || boostPFSConfig.custom.thumbnail_hover_enabled) {
      html = boostPFSTemplate.itemHoverHtml;
      if (boostPFSConfig.custom.thumbnail_hover_enabled) {
        var itemProductInfoHover = '<div class="quick-shop__info animated fadeInDown">' +
          '<div class="thumbnail-overlay">' +
          '<div class="info text-align-center">' +
          '{{itemProductInfo}}' +
          '</div>' +
          '</div>' +
          '</div>';
        html = html.replace(/{{itemProductInfoHover}}/g, itemProductInfoHover);
      } else {
        html = html.replace(/{{itemProductInfoHover}}/g, '');
        html = html.replace(/{{itemReviews}}/g, '');
      }
      if (!boostPFSConfig.custom.enable_quickshop) {
        html = html.replace(/{{itemQuickShop}}/g, '');
      }
    }
    return html;
  }

  function buildPrice(data) {
    var html = '';
    var onSale = data.compare_at_price_max > data.price_min;
    var soldOut = !data.available;
    var priceVaries = data.price_max != data.price_min;
    //console.log(data.price_min, onSale, soldOut)
    html += '<span class="product-thumbnail__price price ' + (onSale ? 'sale' : '') + '"> ';
    if (data.price_min > 0) {
      if (priceVaries) {
        html += '<small><em>' + boostPFSConfig.label.from + '</em></small> ';
      }
      html += '<span class="money">' + Utils.formatMoney(data.price_min, '') + '</span> ';
    } else {
      html += boostPFSConfig.custom.free_price_text;
    }
    // if (onSale) {
    //   html += '<span class="product-thumbnail__was-price compare-at-price">' +
    //     '<span class="money">List: ' + Utils.formatMoney(data.compare_at_price_max, '') + '</span>' +
    //     '</span>';
    // }

    return html;
  }

  function buildSwatch(data) {
    var html = '';
    var values = [];
    var swatchItems = [];
    if (boostPFSConfig.custom.collection_swatches) {
      data.variants.forEach(function (variant) {
        var colorValue = '';
        var optionValue = '';
        variant.merged_options.forEach(function (option) {
          var key = option.split(':')[0];
          var value = option.split(':')[1];
          if ((key.toLowerCase().indexOf('color') != -1 || key.toLowerCase().indexOf('colour') != -1) && values.indexOf(value.toLowerCase()) == -1) {
            values.push(value.toLowerCase());
            colorValue = value;
            optionValue = key;
          }
        });
        if (colorValue) {
          var swatchItem = '<a href="{{variantUrl}}" class="swatch swatch__style--{{swatchShape}}" data-swatch-name="meta-{{slugifyOptionValue}}_{{slugifyColorValue}}">' +
            '<span data-image="{{variantImage}}" style="background-color: {{colorBackground}}; background-image: url({{variantImage}});">' +
            '<img class="swatch__image" src="{{colorImage}}" onerror="this.className += \' swatch__image--empty\'">' +
            '</span>' +
            '</a>';

          swatchItem = swatchItem.replace(/{{swatchShape}}/g, boostPFSConfig.custom.collection_swatches_shape);
          swatchItem = swatchItem.replace(/{{colorBackground}}/g, Utils.slugify(colorValue).split('-').pop());
          swatchItem = swatchItem.replace(/{{slugifyOptionValue}}/g, Utils.slugify(optionValue).replace('-', '_'));
          swatchItem = swatchItem.replace(/{{slugifyColorValue}}/g, Utils.slugify(colorValue).replace('-', '_'));
          swatchItem = swatchItem.replace(/{{variantUrl}}/g, Utils.buildProductItemUrl(data) + '?variant=' + variant.id);

          var colorImage = boostPFSAppConfig.general.file_url.split('?')[0] + Utils.slugify(colorValue) + '_50x.png';
          swatchItem = swatchItem.replace(/{{colorImage}}/g, colorImage);

          var variantImage = '';
          var noImageClass = '';
          if (variant.image) {
            switch (boostPFSConfig.custom.products_per_row) {
              case 2: variantImage = Utils.optimizeImage(variant.image, '600x'); break;
              case 3: variantImage = Utils.optimizeImage(variant.image, '500x'); break;
              default: variantImage = Utils.optimizeImage(variant.image, '400x'); break;
            }
          }
          swatchItem = swatchItem.replace(/{{variantImage}}/g, variantImage);
          swatchItems.push(swatchItem);
        }
      })
    }
    if (swatchItems.length > 0) {
      html = '<div class="thumbnail-swatch is-justify-' + boostPFSConfig.custom.thumbnail_text_alignment + ' is-flex-wrap">' +
        swatchItems.join(' ') +
        '</div>';
    }
    return html;
  }

  function bgset(image) {
    var bgset = '';
    if (image) {
      var aspect_ratio = image.width / image.height;

      if (image.width > 180) bgset += ' ' + Utils.optimizeImage(image.src, '180x') + ' 180w ' + Math.round(180 / aspect_ratio) + 'h,';
      if (image.width > 360) bgset += ' ' + Utils.optimizeImage(image.src, '360x') + ' 360w ' + Math.round(360 / aspect_ratio) + 'h,';
      if (image.width > 540) bgset += ' ' + Utils.optimizeImage(image.src, '540x') + ' 540w ' + Math.round(540 / aspect_ratio) + 'h,';
      if (image.width > 720) bgset += ' ' + Utils.optimizeImage(image.src, '720x') + ' 720w ' + Math.round(720 / aspect_ratio) + 'h,';
      if (image.width > 900) bgset += ' ' + Utils.optimizeImage(image.src, '900x') + ' 900w ' + Math.round(900 / aspect_ratio) + 'h,';
      if (image.width > 1080) bgset += ' ' + Utils.optimizeImage(image.src, '1080x') + ' 1080w ' + Math.round(1080 / aspect_ratio) + 'h,';
      if (image.width > 1296) bgset += ' ' + Utils.optimizeImage(image.src, '1296x') + ' 1296w ' + Math.round(1296 / aspect_ratio) + 'h,';
      if (image.width > 1512) bgset += ' ' + Utils.optimizeImage(image.src, '1512x') + ' 1512w ' + Math.round(1512 / aspect_ratio) + 'h,';
      if (image.width > 1728) bgset += ' ' + Utils.optimizeImage(image.src, '1728x') + ' 1728w ' + Math.round(1728 / aspect_ratio) + 'h,';
      if (image.width > 1950) bgset += ' ' + Utils.optimizeImage(image.src, '1950x') + ' 1950w ' + Math.round(1950 / aspect_ratio) + 'h,';
      if (image.width > 2100) bgset += ' ' + Utils.optimizeImage(image.src, '2100x') + ' 2100w ' + Math.round(2100 / aspect_ratio) + 'h,';
      if (image.width > 2260) bgset += ' ' + Utils.optimizeImage(image.src, '2260x') + ' 2260w ' + Math.round(2260 / aspect_ratio) + 'h,';
      if (image.width > 2450) bgset += ' ' + Utils.optimizeImage(image.src, '2450x') + ' 2450w ' + Math.round(2450 / aspect_ratio) + 'h,';
      if (image.width > 2700) bgset += ' ' + Utils.optimizeImage(image.src, '2700x') + ' 2700w ' + Math.round(2700 / aspect_ratio) + 'h,';
      if (image.width > 3000) bgset += ' ' + Utils.optimizeImage(image.src, '3000x') + ' 3000w ' + Math.round(3000 / aspect_ratio) + 'h,';
      if (image.width > 3350) bgset += ' ' + Utils.optimizeImage(image.src, '3350x') + ' 3350w ' + Math.round(3350 / aspect_ratio) + 'h,';
      if (image.width > 3750) bgset += ' ' + Utils.optimizeImage(image.src, '3750x') + ' 3750w ' + Math.round(3750 / aspect_ratio) + 'h,';
      if (image.width > 4100) bgset += ' ' + Utils.optimizeImage(image.src, '4100x') + ' 180w ' + Math.round(4100 / aspect_ratio) + 'h,';
      bgset += ' ' + image.src + ' ' + image.width + 'w ' + image.height + 'h,';
    }
    return bgset;
  }

  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct

    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage > 1) {
      var paginationHtml = boostPFSTemplate.paginateHtml;
      // Build Previous
      var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
      // Build Next
      var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
      // Create page items array
      var beforeCurrentPageArr = [];
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...');
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);
      var afterCurrentPageArr = [];
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...');
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }
      // Build page items
      var pageItemsHtml = '';
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }

    return '';
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
        }
        var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
        return html;
      }
    }
    return '';
  };

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data
    if (!eventType) eventType = this.eventType

    if (boostPFSConfig.custom.enable_quickshop && data.length > 0) {
      var count = 0;
      data.forEach(function (product) {
        var url = Utils.buildProductItemUrl(product, true);
        jQ.ajax({
          type: "GET",
          url: url + '?view=boost-pfs-quickview',
          success: function (result) {
            if (jQ('[data-boost-pfs-quickshop-id="' + product.id + '"]').length == 1) {
              jQ('[data-boost-pfs-quickshop-id="' + product.id + '"]').replaceWith(result);
            }
            count++;
            if (count == data.length) {
              buildTheme();
            }
          }
        });
      })
    } else {
      buildTheme();
    }
  };

  // Build additional elements
  Filter.prototype.afterRender = function (data, eventType) { };

  function buildTheme() {
    if (window.SPR && typeof SPR.initDomEls == 'function' && typeof SPR.loadBadges == 'function') {
      SPR.initDomEls();
      SPR.loadBadges();
    }

    if (typeof Shopify.PaymentButton != 'undefined' && typeof Shopify.PaymentButton.init == 'function') {
      Shopify.PaymentButton.init();
    }

    if (boostPFSConfig.custom.hasOwnProperty('show_multiple_currencies') &&
      boostPFSConfig.custom.show_multiple_currencies == true &&
      typeof convertCurrencies == 'function') {
      convertCurrencies();
    }
  }
})();

FilterResult.prototype.afterRender = function() {  
  var data = this.data;  
  console.log(data);
  $('.jdgm-preview-badge').each(function(){
    var badgeRating = $(this);
    $(this).prev().find('.product-thumbnail__title').after(badgeRating);
  });
  
  data.products.forEach((item, index)=>{
    var badge =  $('.product__grid-item').eq(index).find('.jdgm-prev-badge');
    var afterSingularText = "review";
    var afterPluralText = "reviews";
    var afterText = afterPluralText;
    if(item.review_count<2){
      afterText = afterSingularText;
    }
    else{
      afterText = afterPluralText;
    }
    badge.append('<span>'+item.review_ratings.toFixed(1)+'</span>');
    badge.append('<span style="display: block">'+item.review_count+' '+afterText+'</span>');
  });

}